import {
  SET_LAW_PAGE_DATA,
  SET_LAW_TYPES_DATA,
  LAW_LOADER,
  DOWNLOAD_COUNT,
  SET_SINGLE_LAW_TYPE,
  DOWNLOAD_LAW_TYPE_COUNT,
  FETCH_CATEGORIES,
  FETCH_COUNTRY_ALBUM,
} from "../actionTypes";

const initialState = {
  loader: false,
  lawPageData: {},
  singleLaw: {},
  laws: {},
  lawTypes: {},
  countryAlbum: [],
};

const lawReducer = (state = initialState, action) => {
  switch (action.type) {
    case LAW_LOADER:
      return {
        ...state,
        loader: action?.payload,
      };
    case SET_LAW_TYPES_DATA: {
      return {
        ...state,
        laws: action.payload,
      };
    }
    case FETCH_COUNTRY_ALBUM: {
      return {
        ...state,
        countryAlbum: action.payload,
      };
    }
    case FETCH_CATEGORIES: {
      return {
        ...state,
        lawTypes: action.payload,
      };
    }
    case SET_SINGLE_LAW_TYPE: {
      return {
        ...state,
        singleLaw: action.payload,
      };
    }
    case SET_LAW_PAGE_DATA: {
      return {
        ...state,
        lawPageData: action.payload,
      };
    }
    case DOWNLOAD_COUNT: {
      if (action.payload == "fileview") {
        return {
          ...state,
          lawPageData: {
            ...state.lawPageData,
            fileViewCount: (state.lawPageData?.fileViewCount || 0) + 1,
          },
        };
      } else
        return {
          ...state,
          lawPageData: {
            ...state.lawPageData,
            downloadCount: (state.lawPageData?.downloadCount || 0) + 1,
          },
        };
    }
    // case DOWNLOAD_LAW_TYPE_COUNT: {
    //   const updatedLawTypes = Array.isArray(state.singleLaw.lawTypes)
    //     ? state.singleLaw.lawTypes.map((law) => {
    //         if (law.id === action.payload.id) {
    //           return {
    //             ...law,
    //             downloadCount: (law.downloadCount || 0) + 1,
    //           };
    //         }
    //         return law;
    //       })
    //     : [];

    //   return {
    //     ...state,
    //     singleLaw: {
    //       ...state.singleLaw,
    //       lawTypes: updatedLawTypes,
    //     },
    //   };
    // }

    default:
      return state;
  }
};

export default lawReducer;
